import React from 'react';
import ReactDOM from 'react-dom';

import * as S from './styles';

class Overlay extends React.PureComponent {
  state = {
    isActive: false,
  };

  componentDidMount() {
    this.setState({ isActive: true });
  }

  render() {
    if (!this.state.isActive) {
      return null;
    }

    return ReactDOM.createPortal(
      <S.Overlay {...this.props} />,
      document.getElementById('root-overlay')
    );
  }
}

export default Overlay;
